import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { FFT_CMP_GROUP_SET } from '../../../function/GroupDataModel';
import { LogD } from '../../../function/LogLapper';
import Grid, { GridSpacing } from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { useTranslation } from 'react-i18next';
import { GetGroupDeviceSelect } from '../../../function/GroupDataModel';
import PhaseCurrentSelectItem, { PhaseCurrentSelectData, InitDataType } from './PhaseCurrentSelectItem';
import Typography from '@material-ui/core/Typography';
import SimpleDialog from '../../atoms/Dialog/SimpleDialog';
import { MeasureHighKind } from '../../../Constant';

/**引数 */
type Props = {
  phaseCurrentSelectData: PhaseCurrentSelectData;
};

const PhaseCurrentButtonList: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const history = useHistory();

  const buttonStyle = {
    maxWidth: '180px',
    maxHeight: '35px',
    minWidth: '180px',
    minHeight: '35px',
  };

  const [simpleDialogOpen, setSimpleDialogOpen] = React.useState(false);
  const [showMessage, setShowMessage] = React.useState<string>('');

  /** FFT比較ボタン処理 */
  const handleFftComparisonPageOpen = () => {
    let plc1: number = 0;
    let plc2: number = 0;
    let set1: number = 0;
    let set2: number = 0;

    const selectDt = props.phaseCurrentSelectData;

    GetGroupDeviceSelect().then((r) => {
      console.debug(['=GetGroupDeviceSelect=', r]);
      var targetRows = r.filter((rr) => rr.DEV_INDEX === Number(selectDt.devIndex));

      console.debug(['=targetRows=', targetRows]);
      if (targetRows.length == 0) {
        //エラーメッセージ
        setShowMessage(t('PhaseCurrentButtonList.項目が選択されていません', '項目が選択されていません'));
        setSimpleDialogOpen(true);
        return;
      } else {
        var rtRow = targetRows.find((rt) => rt.NAME_NO == MeasureHighKind.R_CURRENT);
        var stRow = targetRows.find((rt) => rt.NAME_NO == MeasureHighKind.S_CURRENT);
        var ttRow = targetRows.find((rt) => rt.NAME_NO == MeasureHighKind.T_CURRENT);

        var fftgroupSet: FFT_CMP_GROUP_SET = {
          GROUP_NO: 99,
          GROUP_NAME: '',
          DSP_FLG: 0,
          PLC_NO1: rtRow === undefined ? 0 : rtRow.PLC_NO,
          SET_NO1: rtRow === undefined ? 0 : rtRow.SET_NO,
          PLC_NO2: stRow === undefined ? 0 : stRow.PLC_NO,
          SET_NO2: stRow === undefined ? 0 : stRow.SET_NO,
          PLC_NO3: ttRow === undefined ? 0 : ttRow.PLC_NO,
          SET_NO3: ttRow === undefined ? 0 : ttRow.SET_NO,
          KIND1: 0,
          KIND2: 0,
          KIND3: 0,

          Time_No1: selectDt.selectDay + selectDt.selectTime,
          Time_No2: selectDt.selectDay + selectDt.selectTime,
          Time_No3: selectDt.selectDay + selectDt.selectTime,
        };

        //画面遷移
        history.push({
          pathname: '/FFTComparisonPage',
          state: fftgroupSet,
        });
      }
    });
  };

  /**メッセージボックス閉じる */
  const handleSimpleDialogClose = () => {
    setSimpleDialogOpen(false);
  };

  return (
    <Grid container>
      <Grid item xs={2}>
        <Button
          style={buttonStyle}
          variant="contained"
          color="primary"
          onClick={handleFftComparisonPageOpen}
          disableElevation
        >
          {t('PhaseCurrentButtonList.FFT比較', 'FFT比較')}
        </Button>
      </Grid>
      <SimpleDialog
        open={simpleDialogOpen}
        onClose={handleSimpleDialogClose}
        title={t('PhaseCurrentButtonList.グループ選択', 'グループ選択')}
        okText={t('PhaseCurrentButtonList.閉じる', '閉じる')}
        maxWidth={'sm'}
      >
        <Typography>{showMessage}</Typography>
      </SimpleDialog>
    </Grid>
  );
};

export default PhaseCurrentButtonList;
